<template>
    <!-- category icons -->
    <div class="row my-3">
        <div v-for="(icon, x) in homeIconsArr" :key="x" class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-4 mb-4">
            <router-link :to="{ name: 'category-items', params: { category: icon.dbCategory } }">
                <div class="card h-100 splash-icon-box p-2">
                    <img :src="icon.img" :alt="`${icon.name} ${icon.alt}`" class="splash-icon">
                    <p class="splash-text d-none d-sm-block">{{x+1}}. {{icon.text}}</p>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Icons',
    props: {
        exploreCategory: {
            type: Boolean,
            required: false
        },
        excludeCategory: {
            type: String,
            required: false
        },
    },
    data() {
        return {
            anewitemIconAlt: "related items on anewitem.com",
            cosmeticsIcon: require('../../../../../public/img/web/splash-icons/anewitem-cosmetics.svg'),
            carsIcon: require('../../../../../public/img/web/splash-icons/anewitem-cars.svg'),
            electronicsIcon: require('../../../../../public/img/web/splash-icons/anewitem-electronics.svg'),
            maleFootwearIcon: require('../../../../../public/img/web/splash-icons/anewitem-male-shoe.svg'),
            femaleFootwearIcon: require('../../../../../public/img/web/splash-icons/anewitem-female-shoe.svg'),
            maleFashionIcon: require('../../../../../public/img/web/splash-icons/anewitem-male-fashion.svg'),
            femaleFashionIcon: require('../../../../../public/img/web/splash-icons/anewitem-female-fashion.svg'),
            handBagIcon: require('../../../../../public/img/web/splash-icons/anewitem-bags.svg'),
            hairBrushIcon: require('../../../../../public/img/web/splash-icons/anewitem-hair-brush.svg'),
            babyIcon: require('../../../../../public/img/web/splash-icons/anewitem-baby.svg'),
            laptopIcon: require('../../../../../public/img/web/splash-icons/anewitem-laptop.svg'),
            machineryIcon: require('../../../../../public/img/web/splash-icons/anewitem-machinery.svg'),
            phonesIcon: require('../../../../../public/img/web/splash-icons/anewitem-phones.svg'),
            headphonesIcon: require('../../../../../public/img/web/splash-icons/anewitem-headphones.svg'),
            realEstateIcon: require('../../../../../public/img/web/splash-icons/anewitem-real-estate.svg'),
            soccerIcon: require('../../../../../public/img/web/splash-icons/anewitem-soccer.svg'),
            wristWatchesIcon: require('../../../../../public/img/web/splash-icons/anewitem-wrist-watches.svg'),
            gamesIcon: require('../../../../../public/img/web/splash-icons/anewitem-games.svg'),
            toysIcon: require('../../../../../public/img/web/splash-icons/anewitem-toys.svg'),
            booksIcon: require('../../../../../public/img/web/splash-icons/anewitem-books.svg'),
            decorIcon: require('../../../../../public/img/web/splash-icons/anewitem-decors.svg'),
            graphicsIcon: require('../../../../../public/img/web/splash-icons/anewitem-graphics.svg'),
            furnitureIcon: require('../../../../../public/img/web/splash-icons/anewitem-furnitures.svg'),
            requestIcon: require('../../../../../public/img/web/splash-icons/anewitem-requests.svg'),
        }
    },
    computed: {
        homeIconsArr() {
            if(this.homeIcons && this.exploreCategory && this.excludeCategory){
                
                // filter out the active or displayed category
                let filteredCategory = this.homeIcons.filter(category => category.dbCategory != this.excludeCategory)
                
                // shuffle the icons here and return only 12 icons
                let iconsArr = filteredCategory
                for(let i=0; i < iconsArr.length; i++){
                    let j = Math.floor(Math.random() * i)
                    let temp = iconsArr[i]
                    iconsArr[i] = iconsArr[j]
                    iconsArr[j] = temp
                }
                return iconsArr.slice(0, 12)
            }
            return this.homeIcons
        },
        homeIcons() {
            return [
                {
                    name: 'Laptop',
                    dbCategory: 'laptop',
                    img: this.laptopIcon,
                    text: 'Laptops / Desktops / Computer Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Electronics',
                    dbCategory: 'electronics',
                    img: this.electronicsIcon,
                    text: 'Electronics / Home Appliances Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Phones',
                    dbCategory: 'phones',
                    img: this.phonesIcon,
                    text: 'iPhones / Androids / Phones Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Male Fashion',
                    dbCategory: 'fashion (male)',
                    img: this.maleFashionIcon,
                    text: 'Male Clothes / Fashion Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Female Fashion',
                    dbCategory: 'fashion (female)',
                    img: this.femaleFashionIcon,
                    text: 'Female Clothes / Fashion Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Cars',
                    dbCategory: 'cars',
                    img: this.carsIcon,
                    text: 'Cars / Trucks / Vehicle Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Games and Entertainment',
                    dbCategory: 'games',
                    img: this.gamesIcon,
                    text: 'Game Consoles / Entertainment Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Wristwathes',
                    dbCategory: 'wrist watches',
                    img: this.wristWatchesIcon,
                    text: 'Unisex Watch / Smart Watch Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Headphones',
                    dbCategory: 'headphones',
                    img: this.headphonesIcon,
                    text: 'Headphones / AirPods / Music Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Cosmetics',
                    dbCategory: 'cosmetics',
                    img: this.cosmeticsIcon,
                    text: 'Cosmetics / Makeup Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Unisex bags and pocket books',
                    dbCategory: 'bags',
                    img: this.handBagIcon,
                    text: 'Unisex Bags / Purses / Wallet Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Soccer',
                    dbCategory: 'soccer',
                    img: this.soccerIcon,
                    text: 'Soccer / Sports / Exercise Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Unisex hair care and products',
                    dbCategory: 'hair products',
                    img: this.hairBrushIcon,
                    text: 'Unisex Hair Products / Care Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Male footwares',
                    dbCategory: 'footwears (male)',
                    img: this.maleFootwearIcon,
                    text: 'Male Footwears / Shoes Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Female footwares',
                    dbCategory: 'footwears (female)',
                    img: this.femaleFootwearIcon,
                    text: 'Female Footwears / Shoes Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Baby',
                    dbCategory: 'baby',
                    img: this.babyIcon,
                    text: 'Baby / Kids / Care Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Toys',
                    dbCategory: 'toys',
                    img: this.toysIcon,
                    text: 'Toys / Children / Play Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Books',
                    dbCategory: 'books',
                    img: this.booksIcon,
                    text: 'Books / Educational Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Graphics and Paintings',
                    dbCategory: 'graphics',
                    img: this.graphicsIcon,
                    text: 'Graphics / Paintings Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Furnitures',
                    dbCategory: 'furniture',
                    img: this.furnitureIcon,
                    text: 'Furnitures / Office / Home Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Interior Decorations',
                    dbCategory: 'indoors',
                    img: this.decorIcon,
                    text: 'Interior Decorations / Antique Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Machinery',
                    dbCategory: 'machinery',
                    img: this.machineryIcon,
                    text: 'Machinery / Equipment / Tools Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Real Estate',
                    dbCategory: 'real estate',
                    img: this.realEstateIcon,
                    text: 'Real Estate / Property / Garden Items',
                    alt: this.anewitemIconAlt
                },
                {
                    name: 'Item Request Form',
                    dbCategory: 'item request',
                    img: this.requestIcon,
                    text: 'Looking for something else? Request it',
                    alt: this.anewitemIconAlt
                },
            ]
        }
    }
}
</script>
